<script>
import DashCard from "@/components/Cards/DashCard";

export default {
    props: {
        stats: {}
    },
    components: { DashCard }
};
</script>

<template>
    <div class="row">
        <div class="col-12 col-md">
            <dash-card
                :title="$t('dashboard.box_hours_today')"
                :value="stats.time_today | toTime"
                :progress="stats.time_today_perc"
                icon="far fa-clock"
                :navigate="{ name: 'Dashboard' }"
            >
                <template slot="footer">
                    {{ $t("dashboard.see_details") }}
                    <i class="far fa-angle-right"></i
                ></template>
            </dash-card>
        </div>

        <div class="col-12 col-md">
            <dash-card
                :title="$t('dashboard.box_hours_this_week')"
                :value="stats.time_week | toTime"
                :disable-progress="true"
                icon="far fa-calendar-week"
                :navigate="{ name: 'DashboardHoursWeek' }"
            >
                <template slot="footer">
                    {{ $t("dashboard.see_details") }}
                    <i class="far fa-angle-right"></i>
                </template>
            </dash-card>
        </div>

        <div class="col-12 col-md">
            <dash-card
                :title="$t('dashboard.box_hours_this_month')"
                icon="far fa-calendar-alt"
                :navigate="{ name: 'DashboardHoursMonth' }"
                :value="stats.time_month | toTime"
                :disable-progress="true"
            >
                <template slot="footer"
                    >{{ $t("dashboard.see_details") }}
                    <i class="far fa-angle-right"></i></template
            ></dash-card>
        </div>

        <div class="col-12 col-md">
            <dash-card
                :title="$t('dashboard.box_open_days')"
                icon="far fa-calendar-exclamation"
                :navigate="{ name: 'DashboardOpenDays' }"
                :value="stats.open_days"
                :disable-progress="true"
            >
                <template slot="footer">
                    {{ $t("dashboard.see_days") }}
                    <i class="far fa-angle-right"></i></template
            ></dash-card>
        </div>

        <div class="col-12 col-md" v-if="false">
            <dash-card
                :title="$t('dashboard.box_avg_WK_MON')"
                icon="far fa-tachometer-average"
                :navigate="{ name: 'DashboardAverages' }"
                :value="`${avgWk} | ${avgMon}`"
                :disable-progress="true"
            >
                <template slot="footer">
                    {{ $t("dashboard.see_avg_WK_MON") }}
                    <i class="far fa-angle-right"></i></template
            ></dash-card>
        </div>
    </div>
</template>
